import React from 'react';

const StrategiSimulasiKontesTim: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Berbeda dengan kontes individu, kompetisi pemrograman beregu—seperti pada format International Collegiate Programming Contest (ICPC)—menghadirkan tantangan unik: <b>tiga anggota tim harus berbagi satu komputer selama lima jam penuh</b> untuk memecahkan 10 hingga 15 soal algoritma yang menantang.
      </p>

      <p className="mb-4">
        Dalam situasi ini, tim dengan pemrogram individu paling jenius belum tentu keluar sebagai juara apabila mereka gagal mengelola koordinasi, alur kerja di depan komputer, dan strategi pembagian tugas yang efektif.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Manajemen Pembagian Peran yang Efektif
      </h2>
      <div className="grid md:grid-cols-3 gap-4 mb-4">
        <div className="border border-gray-200 rounded-lg p-3 bg-white">
          <h3 className="font-semibold text-defaultBlue mb-1">🔍 Problem Reader</h3>
          <p className="text-sm text-gray-600">Membaca soal dengan cepat, menerjemahkan deskripsi panjang ke inti matematis, dan menandai tingkat kesulitan.</p>
        </div>
        <div className="border border-gray-200 rounded-lg p-3 bg-white">
          <h3 className="font-semibold text-defaultBlue mb-1">⚡ Fast Implementer</h3>
          <p className="text-sm text-gray-600">Mengetik kode dengan akurasi tinggi dan menguasai sintaks STL untuk mengeksekusi solusi dasar dengan cepat.</p>
        </div>
        <div className="border border-gray-200 rounded-lg p-3 bg-white">
          <h3 className="font-semibold text-defaultBlue mb-1">🧠 Algorithmic Thinker</h3>
          <p className="text-sm text-gray-600">Menganalisis soal berkategori sulit di atas kertas coretan saat anggota lain sedang mengetik di komputer.</p>
        </div>
      </div>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Protokol Penggunaan Satu Komputer
      </h2>
      <p className="mb-4">
        Aturan emas dalam kontes tim adalah: <i>&quot;Jangan pernah duduk mengetik di depan komputer jika algoritma dan kasus batas belum selesai dirancang di atas kertas.&quot;</i> Mengetik sambil memikirkan logika hanya akan memonopoli komputer dan memperlambat rekan tim yang sudah siap mengeksekusi solusinya.
      </p>

      <p className="mb-4">
        Ketika terjadi bug (status Wrong Answer), peserta yang mengetik harus segera mencetak kode ke lembar kertas (<i>printout</i>) dan menyingkir dari komputer untuk melakukan penelusuran manual, memberikan giliran komputer kepada rekan tim berikutnya.
      </p>

      <p className="mb-4">
        Sinergi komunikasi yang harmonis, saling percaya, dan kedisiplinan taktik inilah yang mengubah tiga pemikir individu menjadi satu kesatuan tim yang tangguh dan tak terkalahkan di panggung kompetisi.
      </p>
    </div>
  );
};

export default StrategiSimulasiKontesTim;
